export const AttendanceConstant = {
    ATTENDANCE_MAP:{
        1: "Present",
        2: "Off"
    },
    ATTENDANCE_STATUS_MAP:{
        1: {text: "Pending", colorClass: "orange", statusClas: "status03"},
        2: {text: "Approved", colorClass: "green", statusClas: "status01"},
        3: {text: "Rejected", colorClass: "red", statusClas: "status02"}
    },
    ATTENDANCE_STATUS_LIST:[
        {key: 1,text: "Pending", colorClass: "orange" , flag : false},
        {key: 2,text: "Approved", colorClass: "green" , flag : true},
        {key: 3,text: "Rejected", colorClass: "red" ,flag : true}
    ],

    ATTENDNACE_TYPE_LIST: [
        {key: 1, name: "Present", val: false},
        {key: 3, name: "Leave - Full Day", val: false},
        {key: 4, name: "Leave - Half Day", val: false},
        {key: 5, name: "Festival Holiday", val: false},
        {key: 2, name: "Off", val: false},
        // {key: 1, name: "Present", val: false},

    ],
    LEAVE_TYPE_LIST: [
        {key: 1, name: "Flexi Leave", val: false},
        {key: 2, name: "Festival Leave", val: false},
        {key: 3, name: "Casual Leave", val: false}
    ],


    Team_APPROVAL_COLUMN_HEADER_LIST:[
        {key:"userName",name:"Employee Name",isExportColumn: false},
        {key:"leaveType",name:"Leave Type" ,isExportColumn: false},
        {key:"duration",name:"Duration",isExportColumn: false},
        {key:"count",name:"Count",isExportColumn: false},
        {key:"reason",name:"Reason",isExportColumn: false},
        {key:"status",name:"Status",isExportColumn: false},
        {key:"status",name:"Action",isExportColumn: false},
      
        
    ],
    ATTENDANCE_DAYTYPE_LIST:[
        {key: 1,text: "Full Day"},
        {key: 2,text: "Half Day" },
    ],


}